let BranchSDK = undefined;
export function getBranchSDK() {
  const HasBranchSDK = typeof BranchSDK;

  switch (HasBranchSDK) {
    case 'undefined':
      BranchSDK = import('branch-sdk').then(branch => {
        BranchSDK = window.branch;
        window.branch.init('key_live_dduwTImBLx743248uGpEWlefBEblKrhu');
        return window.branch;
      });
      return BranchSDK;
    default:
      return BranchSDK;
  }
}
